import React from "react";

const WearableIcon = ({ fill = "#444444", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 33.5"
    width="24"
    height="24"
    fill={fill}
    {...props}
  >
    <path d="M6.1 13.8c-1.1-1.1-1.7-2.5-1.7-4S5 6.8 6 5.7 8.5 4 10 4s3 .6 4.1 1.6L15.4 7l2.5-2.6-1.4-1.3C14.7 1.4 12.4.4 9.9.5c-2.5 0-4.8 1-6.5 2.8C1.7 5 .7 7.4.8 9.9c0 2.5 1 4.8 2.8 6.5L5 17.7l2.5-2.6zM19 26.4l-7.4-7.2-2.5 2.6 8.7 8.4 1.3 1.2 1.2-1.2 8.4-8.7-2.5-2.5z" />
    <path d="M34 2.9C32.2 1.2 29.9.2 27.4.3c-2.5 0-4.8 1-6.5 2.8l-1.3 1.4-13.8 14L8.3 21l14-14.4 1.1-1.1c1.1-1.1 2.5-1.7 4-1.7s3 .6 4.1 1.6c2.3 2.2 2.3 5.8.1 8.1l-1.3 1.4 2.6 2.5 1.3-1.4c1.7-1.8 2.7-4.1 2.6-6.6S35.7 4.6 34 2.9" />
    <path d="m32 18.147-2.514 2.576-9.948-9.708 2.514-2.576z" />
  </svg>
);

export default WearableIcon;
